import Vue from 'vue';
import App from './App.vue';
import router from '@/router/index';
import store from '@/store/index';
import moment from 'moment';
import interceptor from "@/interceptor";
import '@/directive/tooltip'
import '@/directive/vue-observe-visibility'
import Constants from "@/store/constants";
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import { staging, production } from '../auth_config';
import PrimeVue from 'primevue/config';


// Import the plugin here
import { Auth0Plugin } from './auth';
import 'bootstrap-vue/dist/bootstrap-vue.css'
//theme
import "primevue/resources/themes/nova/theme.css";
import "primeflex/primeflex.css";

//core
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";
const host = document.location.host;
let prodUrl = 'musicmanager.storever.com';
let stagingUrl = 'musicmanager-staging.storever.com';
let localUrl = 'localhost:8080';
let domain =  staging.domain ;
let clientId =  staging.clientId;
interceptor();

Vue.config.productionTip = true;
Vue.prototype.getLabelName = (labelCategoryId) => (Constants.labelCategoryID[parseInt(labelCategoryId)] ||{}).text;
Vue.prototype.pad = function (size) {
    var s = String(this);
    while (s.length < (size || 2)) { s = "0" + s; }
    return s;
}
Vue.prototype.decimalMinToMoment=function(mins){
    let timeInSeconds = mins * 60;
    const pad = (num, size) => ('000' + num).slice(size * -1) ;
    const time = +(timeInSeconds).toFixed(3);
    const hours = ~~(time / 60 / 60);
    const minutes = ~~(time / 60) % 60;
    const seconds = ~~(time - minutes * 60);

    return pad(hours, 2) + ':' + pad(minutes, 2) + ':' + pad(seconds, 2);
}
Vue.prototype.minToMoment=function(mins){
    var h = parseInt(mins / 60);
    var m = parseInt(mins % 60);
    return moment((h < 10 ? ("0" + h) : h) + ':' + (m < 10 ? ("0" + m) : m)+":00", "HH:mm:ss")
}
Vue.prototype.getMinSec = (ms) => {
    let sec = parseInt(ms/1000);
    const hours = parseInt(sec/3600); // 3,600 sec in 1 hour
    sec = sec % 3600; // sec remaining after extracting hours
    let min = parseInt(sec/60); // 60 sec in 1 minute
    sec = sec % 60;
    if (sec < 10) {
        sec = `0${sec}`;
    }
    return { sec, min }
},
Vue.prototype.$log = function (data) {
    console.log('TPL => ', JSON.stringify(data));
}
if ('musicmanager-staging.mcubedigital.com' === host || 'musicmanager.mcubedigital.com' === host) {
     prodUrl = 'musicmanager.mcubedigital.com';
     stagingUrl = 'musicmanager-staging.mcubedigital.com';
     domain = (host === stagingUrl ? staging.domain : production.domain);
     clientId = (host === stagingUrl   ? staging.clientId : production.clientId);
} else if ( 'musicmanager-qa.mcubedigital.com' === host) {
    prodUrl = 'musicmanager-qa.mcubedigital.com';
    stagingUrl = 'musicmanager-staging.mcubedigital.com';
    domain = (host === stagingUrl ? staging.domain : production.domain);
    clientId = (host === stagingUrl   ? staging.clientId : production.clientId);
}
else{
     domain = ((host === stagingUrl || host === localUrl) ? staging.domain : production.domain);
     clientId = ((host === stagingUrl || host === localUrl)  ? staging.clientId : production.clientId);
}

console.log(domain, clientId)
Vue.use(Auth0Plugin, {
    domain,
    clientId,
    onRedirectCallback: appState => {
        router.push(
            appState && appState.targetUrl
                ? appState.targetUrl
                : window.location.pathname
        );
    }
});

new Vue({
    store,
    router,
    render: h => h(App)
}).$mount('#app');
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.use(PrimeVue);

